export const getUrlHostname = (url: string): string | undefined => {
  const match = url.match(/^https?:\/\/([^/?#]+)/i);
  if (!match?.[1]) {
    return undefined;
  }

  return match[1].split(':')[0].toLowerCase();
};
